export default __webpack_public_path__ + "static/media/money2.433df22e.jpg";